// extracted by mini-css-extract-plugin
module.exports = {"megaMenu":"MegaNav_megaMenu_19lvI","isStyleA":"MegaNav_isStyleA_3KYw-","isStyleB":"MegaNav_isStyleB_XKmfw"};